<template>
    <div class="admin-members">

        <div class="row align-items-center mb-3">
            <div class="col-6">
                <div class="input-group">
                    <input v-model="search" @keyup.enter="updateMembers" type="text" class="form-control" id="member-search" placeholder="Member Search ...">
                    <button type="button" class="btn bg-transparent" @click="search='';updateMembers()" style="margin-left: -40px; z-index: 100;">
                        <i class="fa-solid fa-xmark text-muted"></i>
                    </button>
                </div>
            </div>
            <div class="col-6">
                <div class="form-check form-check-inline">
                    <input v-model="includeMembers" @change="updateMembers" type="checkbox" class="form-check-input" id="selectMembers" checked="checked">
                    <label class="form-check-label text-light" for="selectMembers">Accounts (<strong>{{ metrics.members }}</strong>)</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="includeVips" @change="updateMembers" type="checkbox" class="form-check-input" id="selectVips" checked="checked">
                    <label class="form-check-label text-light" for="selectVips">VIPs ({{ metrics.vips }})</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="includeAdmins" @change="updateMembers" type="checkbox" class="form-check-input" id="selectAdminMembers" checked="checked">
                    <label class="form-check-label text-light" for="selectAdminMembers">Admins ({{ metrics.admins }})</label>
                </div>
            </div>
        </div>

        <div class="text-light small">{{ foundMembersCount }} Members Found</div>
        <table class="table bg-light table-striped members-list">
            <thead class="bg-light text-dark small">
            <tr>
                <th scope="col" class="d-none d-md-table-cell"></th>
                <th scope="col" class="d-none d-md-table-cell"><a href="#" @click.prevent="setSort('membership_id')" class="text-dark text-nowrap"><i class="fa-solid fa-trophy-star"></i></a></th>
                <th scope="col">Name (ID)</th>
                <th scope="col" class="d-none d-md-table-cell">Email</th>
                <th scope="col"><a href="#" @click.prevent="setSort('created_at')" class="text-dark text-nowrap"><i class="fa-solid" :class="sortIcon('created_at')"></i> Joined</a></th>
                <th scope="col" class="d-none d-lg-table-cell" style="width: 100px">Segment</th>
                <th scope="col" class="text-center"><a href="#" @click.prevent="setSort('available_tokens')" class="text-dark text-nowrap"><i class="fa-solid" :class="sortIcon('available_tokens')"></i> Tokens</a></th>
                <!-- <th scope="col" class="d-lg-none text-center"><a href="#" @click.prevent="setSort('collection_count')" class="text-dark text-nowrap"><i class="fa-solid" :class="sortIcon('collection_count')"></i> Coll</a></th> -->
                <th scope="col" class="text-center"><a href="#" @click.prevent="setSort('own_count')" class="text-own text-nowrap"><i class="fa-solid" :class="sortIcon('own_count')"></i> Own</a></th>
                <th scope="col" class="d-none d-lg-table-cell text-center"><a href="#" @click.prevent="setSort('trade_count')" class="text-trader text-nowrap"><i class="fa-solid" :class="sortIcon('trade_count')"></i> Trade</a></th>
                <!-- <th scope="col" class="d-none d-xl-table-cell text-center small"><a href="#" @click.prevent="setSort('scrapper_count')" class="text-scrapper text-nowrap"><i class="fa-solid" :class="sortIcon('scrapper_count')"></i> Fakes</a></th> -->
                <th scope="col" class="d-none d-lg-table-cell text-center"><a href="#" @click.prevent="setSort('iso_count')" class="text-iso text-nowrap"><i class="fa-solid" :class="sortIcon('iso_count')"></i> ISO</a></th>
                <th scope="col" class="d-none d-xl-table-cell text-center"><a href="#" @click.prevent="setSort('grail_count')" class="text-grail text-nowrap"><i class="fa-solid" :class="sortIcon('grail_count')"></i> Grail</a></th>
                <th scope="col" class="d-none d-xl-table-cell text-center"><a href="#" @click.prevent="setSort('pin_book_count')" class="text-album text-nowrap"><i class="fa-solid" :class="sortIcon('pin_book_count')"></i> Books</a></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(member, index) in filteredMembers" :key="member.id" :class="{ 'admin-member' : member.is_admin }">
                <td class="d-none d-md-table-cell small text-muted">{{ index+1 }}</td>
                <td class="d-none d-md-table-cell">
                    <i v-if="member.membership_id && member.membership_id > 1" class="fa-solid fa-trophy-star" :class="'text-' + meta.subscriptions.find(s => s.id === member.membership_id).class" :title="meta.subscriptions.find(s => s.id === member.membership_id).name"></i>
                    <!-- <svg v-if="member.membership_id && member.membership_id === 1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0,0,100,100">
                        <circle cx="50" cy="50" r="44" fill="white" stroke="black" stroke-width="12" />
                        <circle cx="50" cy="50" r="35" fill="black" />
                        <polygon points="50,25 35,70 73,42 26,42 65,70" style="fill:white;"/>
                    </svg> -->
                </td>
                <td class="member-name">
                    <a href="#" @click.prevent="memberDeets = member" data-bs-toggle="modal" data-bs-target="#memberDeets">
                        <span class="d-none d-sm-inline"><i v-if="member.membership_id && member.membership_id > 1" class="d-md-none fa-solid fa-trophy-star" :class="'text-' + meta.subscriptions.find(s => s.id === member.membership_id).class"></i> {{ member.username }}</span>
                        <span class="d-sm-none small"><i v-if="member.membership_id && member.membership_id > 1" class="fa-solid fa-trophy-star" :class="'text-' + meta.subscriptions.find(s => s.id === member.membership_id).class"></i> {{ member.username.length > 18 ? member.username.substring(0,15)+"..." : member.username }}</span></a>
                    <small class="text-muted d-none d-sm-inline"> ({{ member.id }})</small>
                    <div class="small text-muted">
                        <span class="d-none d-sm-block">{{ member.name }}</span>
                        <span class="d-sm-none">{{ member.name.length > 18 ? member.name.substring(0,15)+"..." : member.name }}</span>
                    </div>
                    <div class="small d-md-none">{{ member.email.length > 18 ? member.email.substring(0,15)+"..." : member.email }}</div>
                    <div v-if="member.is_mod" class="small fw-bold text-info">MOD</div>
                </td>
                <td class="d-none d-md-table-cell small">{{ member.email }}</td>
                <td class="small">
                    <span class="text-nowrap d-none d-sm-inline-block">{{ member.joined }}</span>
                    <span class="text-nowrap d-sm-none">{{ member.joined.substring(0,10) }}</span>
                    <div class="small d-lg-none mt-1 text-muted">{{ member.segment }}</div>
                </td>
                <td class="d-none d-lg-table-cell small" style="width: 100px">{{ member.segment }}</td>
                <td class="text-center">{{ member.available_tokens ?? 0 }}</td>
                <!-- <td class="d-lg-none text-center">{{ member.collection_count }}</td> -->
                <td class="text-center own-count" :class="{'has-own': member.own_count}">{{ member.own_count }}</td>
                <td class="d-none d-lg-table-cell text-center trade-count" :class="{'has-trade': member.trade_count}">{{ member.trade_count }}</td>
                <!-- <td class="d-none d-xl-table-cell text-center scrapper-count">{{ member.scrapper_count }}</td> -->
                <td class="d-none d-lg-table-cell text-center iso-count" :class="{'has-iso': member.iso_count}">{{ member.iso_count }}</td>
                <td class="d-none d-xl-table-cell text-center grail-count" :class="{'has-grail': member.grail_count}">{{ member.grail_count }}</td>
                <td class="d-none d-xl-table-cell text-center album-count" :class="{'has-album': member.pin_book_count}">{{ member.pin_book_count }}</td>
            </tr>
            </tbody>
        </table>

        <div class="modal fade" id="memberDeets" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ memberDeets.username }}
                            <span v-if="memberDeets.membership_id">
                                <i v-if="memberDeets.membership_id > 1" class="fa-solid fa-trophy-star ms-2" :class="'text-' + meta.subscriptions.find(s => s.id === memberDeets.membership_id).class"></i>
                            </span>
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12 col-sm">
                                    <div class="float-end"><span class="text-muted">ID:</span> {{ memberDeets.id }}</div>
                                    <h6>Member:</h6>
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item">
                                            <span class="text-muted">Profile Name:</span> {{ memberDeets.username }}
                                        </li>
                                        <li class="list-group-item">
                                            <span class="text-muted">Name:</span> {{ memberDeets.name }}
                                        </li>
                                        <li class="list-group-item">
                                            <span class="text-muted">Member Since:</span> {{ memberDeets.joined }}
                                        </li>
                                        <li class="list-group-item">
                                            <span class="text-muted">Last Active:</span> {{ memberDeets.activity }}
                                        </li>
                                        <li class="list-group-item">
                                            <span class="text-muted">Email Address:</span> {{ memberDeets.email }}
                                        </li>
                                        <li v-if="memberDeets.ip_address" class="list-group-item">
                                            <span class="text-muted">IP Address:</span> <a :href="'https://iplocation.io/ip/' + memberDeets.ip_address" target="_blank">{{ memberDeets.ip_address }}</a>
                                        </li>
                                        <li v-if="memberDeets.address" class="list-group-item">
                                            {{ memberDeets.address }}
                                            <div>{{ memberDeets.address_2 }}</div>
                                            <div>{{ memberDeets.city }}, {{ memberDeets.state }} {{ memberDeets.zip }} {{ memberDeets.country }}</div>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between">
                                            <a :href="'/u/' + memberDeets.slug" target="_blank"><strong>Profile Page</strong></a>
                                            <a :href="'/admin/trading/check/' + memberDeets.id"><strong>Order Check</strong></a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-12 col-sm mt-4 mt-sm-0">
                                    <h6>Collections:</h6>
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a :href="'/u/' + memberDeets.slug + '/owns'"><i class="fa-regular fa-circle-check"></i> Pins Owned</a> <span class="badge bg-own rounded-pill">{{ memberDeets.own_count }}</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a :href="'/u/' + memberDeets.slug + '/traders'"><i class="fa-regular fa-right-left"></i> Traders</a> <span class="badge bg-trader rounded-pill">{{ memberDeets.trade_count }}</span>
                                        </li>
                                        <!-- <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a :href="'/u/' + memberDeets.slug + '/scrappers'"><i class="fa-regular fa-square-minus"></i> Fakes</a> <span class="badge bg-scrapper rounded-pill">{{ memberDeets.scrapper_count }}</span>
                                        </li> -->
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a :href="'/u/' + memberDeets.slug + '/isos'"><i class="fa-regular fa-magnifying-glass-plus"></i> ISOs</a> <span class="badge bg-iso rounded-pill">{{ memberDeets.iso_count }}</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a :href="'/u/' + memberDeets.slug + '/grails'"><i class="fa-regular fa-crown"></i> Grails</a> <span class="badge bg-grail rounded-pill">{{ memberDeets.grail_count }}</span>
                                        </li>
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a :href="'/u/' + memberDeets.slug + '/pin-books/'"><i class="fa-regular fa-book"></i> Pin Books</a> <span class="badge bg-album rounded-pill">{{ memberDeets.pin_book_count }}</span>
                                        </li>
                                    </ul>

                                    <h6 class="mt-4">Tokens:</h6>
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between align-items-center">
                                            <a data-bs-toggle="collapse" href="#adjustTokens" role="button" aria-expanded="false" aria-controls="adjustTokens"><i class="fa-light fa-coin"></i> Trade Tokens</a> <span class="badge bg-grail rounded-pill">{{ memberDeets.available_tokens }}</span>
                                        </li>
                                    </ul>
                                    <div class="collapse mt-2" id="adjustTokens">
                                        <div class="card card-body py-2 small">
                                            <label for="token-input" class="form-label">Add or remove tokens:</label>
                                            <div class="row g-2 align-items-center">
                                                <div class="col-5">
                                                    <div class="input-group">
                                                        <button @click="tokenAmount--" type="button" class="btn btn-sm btn-outline-secondary">
                                                            <i class="fa-regular fa-minus"></i>
                                                        </button>
                                                        <input type="number" class="form-control form-control-sm" id="token-input" v-model="tokenAmount" placeholder="0">
                                                        <button @click="tokenAmount++" type="button" class="btn btn-sm btn-outline-secondary">
                                                            <i class="fa-regular fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-7">
                                                    <input type="text" class="form-control form-control-sm" id="token-note" v-model="tokenNote" placeholder="note">
                                                </div>
                                                <div class="col-12 text-end">
                                                    <button @click="updateTokens" class="btn btn-sm btn-grail text-light" type="button" :disabled="tokenAmount === 0">Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="memberDeets.segment" class="row mt-4">
                                <div class="col">
                                    <h6>Segments: <strong>{{ memberDeets.segment }}</strong> 
                                        <button class="btn btn-sm btn-link" type="button" data-bs-toggle="collapse" data-bs-target="#all-segments">details</button>
                                    </h6>
                                    <div id="all-segments" class="collapse">
                                        <div v-for="segment in memberDeets.segments" :key="segment.id" class="d-flex py-2 border-bottom">
                                            <div class="small text-muted lh-1 me-4">
                                                <div>{{ new Date(segment.created_at).toLocaleDateString('en-us', {year: 'numeric', month: 'short', day: 'numeric'}) }}</div>
                                                <div class="">{{ new Date(segment.created_at).toLocaleTimeString('en-US') }}</div>
                                            </div>
                                            <strong>{{ segment.outcome }}</strong>
                                            <span v-if="segment.outcome === 'other'">: {{ segment.feedback }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col">
                                    <i class="text-success fa-solid fa-circle-check float-end mt-2" :class="[aliasesUpdated ? 'visible' : 'invisible']"></i>
                                    <label for="aliases" class="form-label text-muted">Search Aliases</label>
                                    <textarea @keydown.enter.prevent="updateAliases" @input="aliasesUpdated=false" class="form-control text-muted" id="aliases" rows="3" v-model="memberDeets.aliases"></textarea>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col">
                                    <a :href="'/admin/members/' + memberDeets.slug + '/impersonate'" class="btn btn-outline-primary"><i class="fa-solid fa-user-secret"></i> Impersonate</a>
                                </div>
                                <div class="col text-end text-sm-center">
                                    <a :href="'mailto:' + memberDeets.email" class="btn btn-outline-primary"><i class="fa-regular fa-paper-plane"></i> Email User</a>
                                </div>
                                <div class="col-12 col-sm-4 text-center text-sm-end mt-4 mt-sm-0">
                                    <div class="dropdown">
                                        <button v-for="subscription in meta.subscriptions" v-if="memberDeets.membership_id === subscription.id" @click="toggleSubscription(0)" class="btn" :class="'btn-' + subscription.class">
                                            <svg v-if="subscription.id === 1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0,0,100,100" class="position-relative me-1" style="top: -1px;">
                                                <circle cx="50" cy="50" r="44" fill="black" stroke="white" stroke-width="12" />
                                                <circle cx="50" cy="50" r="35" fill="white" />
                                                <polygon points="50,25 35,70 73,42 26,42 65,70" style="fill:black;"/>
                                            </svg>
                                            <i v-else class="fa-solid fa-trophy-star"></i>
                                            {{ subscription.name }}
                                        </button>
                                        <span v-if="!memberDeets.membership_id">
                                            <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="patreon-menu-button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fa-solid fa-trophy-star"></i> Subscription
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="patreon-menu-button">
                                                <a v-for="subscription in meta.subscriptions" @click.prevent="toggleSubscription(subscription.id)" class="dropdown-item fw-bold" :class="'text-' + subscription.class" href="#">{{ subscription.name }}</a>
                                            </div>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="spamConfirm" class="modal-footer justify-content-start">
                        Are you sure this account is fake?
                        <button @click="setFake" class="btn btn-danger mx-3" type="button">YES</button>
                        <button @click="spamConfirm = false" type="button" class="btn btn--outline-secondary">NO</button>
<!--                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
                    </div>
                    <div v-else class="modal-footer justify-content-between">
                        <span>
                            <button v-if="!memberDeets.collection_count && !memberDeets.address" @click="spamConfirm = true" type="button" class="btn btn-sm btn-outline-danger">SPAM</button>
                        </span>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
const CancelToken = axios.CancelToken;
let cancel;
import { VueAutosuggest } from 'vue-autosuggest';

    export default {
        components: {
            VueAutosuggest
        },
        name: "AdminMembers",
        props: ['members', 'metrics', 'meta'],
        data: function () {
            return {
                search: '',
                includeAdmins: true,
                includeVips: true,
                includeMembers: true,
                sortBy: 'created_at',
                sortDesc: true,
                spamConfirm: false,
                memberDeets: {
                    username: 'Member Username'
                },
                segments: [],
                aliasesUpdated: false, 
                filteredMembers: this.members,
                tokenAmount: 0,
                tokenNote: null
            }
        },
        mounted() {
            document.getElementById('memberDeets').addEventListener('hidden.bs.modal', () => {
                this.tokenAmount = 0;
                this.tokenNote = null;
            });
        },
        created() {
            if (window.location.hash && window.location.hash !== '#_=_') {
                const hash = window.location.hash.substring(1).replaceAll('+', ' ');
                if (hash === 'vips') {
                    this.includeAdmins = false;
                    this.includeMembers = false;
                } else {
                    this.search = hash;
                }
            }

            this.meta.subscriptions.forEach(s => {
                if (s.id === 5) {
                    s.class = 'grail';
                } else if (s.id === 2) {
                    s.class = 'success';
                } else if (s.id === 3) {
                    s.class = 'trader';
                } else if (s.id === 4) {
                    s.class = 'iso';
                } else {
                    s.class = 'dark';
                }
            });

            this.sortBy = this.meta.sort[0];
            this.sortDesc = this.meta.sort[1];

            if (this.meta.show && this.meta.show.length) {
                this.includeAdmins = this.meta.show.includes('admins');
                this.includeVips = this.meta.show.includes('vips');
                this.includeMembers = this.meta.show.includes('members');
            }

            if (this.meta.search && this.meta.search !== '') {
                this.search = this.meta.search;
            }
        },
        computed: {

            foundMembersCount: function () {
                return this.metrics.total;
            },

            baseMembers: function () {
                return this.members.filter(member => {
                    return !member.is_admin && !member.membership_id;
                });
            },
            adminMembers: function () {
                return this.members.filter(member => {
                    return member.is_admin;
                });
            },
            subscribedMembers: function () {
                return this.members.filter(member => {
                    return member.membership_id;
                });
            }
        },
        methods: {
            
            updateMembers: function () {
                let url = location.protocol + '//' + location.host + location.pathname;
                let query = [];
                query[0] = 'page=1';
                if (!this.includeMembers || !this.includeVips || !this.includeAdmins) {
                    let show = [];
                    if (this.includeMembers) {
                        show.push('members');
                    }
                    if (this.includeVips) {
                        show.push('vips');
                    }
                    if (this.includeAdmins) {
                        show.push('admins');
                    }
                    query[query.length] = 'show=' + show.join(',');
                }

                if (this.sortBy !== 'created_at' || this.sortDesc === 'asc') {
                    query[query.length] = 'sort=' + this.sortBy + ':' + (this.sortDesc ? 'desc' : 'asc');
                }

                if (this.search !== '') {
                    query[query.length] = 'q=' + this.search;
                }

                if (query.length) {
                    url += '?' + query.join('&');
                }

                window.location.href = url;
            },

            onInputChange: function(text) {
                // event fired when the input changes
                // console.log(text);

                // const CancelToken = axios.CancelToken;
                // let cancel;

                let q = text.trimStart().replace(/\s\s+/g, ' ');
                this.query = q;

                if (cancel !== undefined) {
                    cancel();
                    // console.log("cancelled");
                }

                if (q !== '') {
                    axios.get('/autocomplete', {
                        cancelToken: new CancelToken(function executor(c) {
                            cancel = c;
                        }),
                        params: {
                            query: q,
                            searching: this.searching
                        }
                    }).then(response => {
                        this.searchSuggestions[0].data = response.data;
                    }).catch(function (thrown) {
                        if (axios.isCancel(thrown)) {
                            // console.log('Request canceled', thrown.message);
                        } else {
                            // handle error
                        }
                    });
                } else {
                    this.searchSuggestions[0].data = null;
                }
            },

            setSort(sortBy) {
                if (sortBy === this.sortBy) {
                    this.sortDesc = !this.sortDesc;
                } else {
                    this.sortBy = sortBy;
                    this.sortDesc = true;
                }

                this.updateMembers();
            },

            sortIcon: function (col) {
                return [
                    this.sortBy === col ? 'visible' : 'invisible',
                    this.sortDesc ? 'fa-sort-amount-down' : 'fa-sort-amount-down-alt'
                ]
            },
            toggleSubscription: function (level) {
                axios.put('/admin/members/' + this.memberDeets.slug, {
                    subscription: level ?? null
                }).then(response => {
                    if (response.status === 200) {
                        this.memberDeets.membership_id = level ?? null;
                    }
                });
            },
            updateAliases: function () {
                axios.put('/admin/members/' + this.memberDeets.slug, {
                    aliases: this.memberDeets.aliases
                }).then(response => {
                    this.aliasesUpdated = true;
                });
            },
            updateTokens: function () {
                axios.put('/admin/members/' + this.memberDeets.slug, {
                    tokens: this.tokenAmount,
                    note: this.tokenNote
                }).then(response => {
                    this.memberDeets.available_tokens = Number(this.memberDeets.available_tokens) +  Number(this.tokenAmount);
                    this.tokenAmount = 0;
                    this.tokenNote = null;
                });
            },
            setFake: function () {
                axios.delete('/admin/members/' + this.memberDeets.id).then(response => {
                    if (response.status === 200) {
                        window.location.reload();
                    }
                });
            }
        }
    }
</script>
